"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactAutosizeTextarea = _interopRequireDefault(require("react-autosize-textarea"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var handleClick = function handleClick(_ref) {
  var onChange = _ref.onChange,
      hasUpdatePermission = _ref.hasUpdatePermission;
  return function (value) {
    return hasUpdatePermission ? onChange(value) : null;
  };
};

function TextAreaWrapper(_ref2) {
  var onChange = _ref2.onChange,
      hasUpdatePermission = _ref2.hasUpdatePermission,
      content = _ref2.content;
  var placeholder = hasUpdatePermission ? 'Please enter script...' : '';
  return _react.default.createElement(_reactAutosizeTextarea.default, {
    className: (0, _classnames.default)('script__script-input', {
      'script__script-input--editable': hasUpdatePermission
    }),
    onChange: handleClick({
      onChange: onChange,
      hasUpdatePermission: hasUpdatePermission
    }),
    defaultValue: content,
    placeholder: placeholder,
    "data-cy": "edit-script-content",
    readOnly: !hasUpdatePermission
  });
}

var _default = (0, _react.memo)(TextAreaWrapper);

exports.default = _default;